import { render, staticRenderFns } from "./ContentPolicy.vue?vue&type=template&id=b63ad552&"
import script from "./ContentPolicy.vue?vue&type=script&lang=js&"
export * from "./ContentPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContentPolicy.vue"
export default component.exports